var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header-mobile__banner__col"},[_c('h2',{staticClass:"s-header-mobile__submenu-header"},[_vm._v(" "+_vm._s(_vm.activeSubmenuName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }